import { h } from 'preact';
import * as BaseComp from 'components/bolt/header/headerExpanded.js';
import Store from 'store/store';
import { accessNested} from 'utils/utils';
import { getMainPage, isVideosPage } from 'utils/bolt';

export default class HeaderExpanded extends BaseComp.default {

	closeAndNavigate(id, e, linkName) {
		if (Store.get().activePage === 'admissionQuiz') {
			Store.emit('POWSTER_GA_EVENT_TRACK', 'menu-item-click', 'pending', id);
		}
		
		super.closeAndNavigate(id, e, linkName);
	}
}
